import React from "react";

export default function ImageBackgroundComponent(props) {
    return <div className={`${props.class ?? ""}`}></div>;
}
